import type { TitleFinding } from '../../types';
import { renderInlineMd, formatDate } from '../../lib/utils';

interface Props { dealId: string; findings: TitleFinding[]; }

export function TitleFindingsList({ findings }: Props) {
  if (findings.length === 0) {
    return (
      <>
        <div className="col-section">
          <span className="col-section-title">Title Findings · 0</span>
        </div>
        <div className="empty-state" style={{ padding: '14px 22px', textAlign: 'left' }}>
          Findings appear here as Claude extracts them from files
        </div>
      </>
    );
  }
  return (
    <>
      <div className="col-section">
        <span className="col-section-title">Title Findings · {findings.length}</span>
        <button className="col-section-action">Re-run</button>
      </div>
      <div className="title-list">
        {findings.map(f => (
          <button key={f.id} className="title-finding">
            <div className="title-finding-head">
              <span className="title-finding-doc">{f.docType} · {f.docNumber}</span>
              <span className="title-finding-date">{formatDate(f.date)}</span>
            </div>
            <div
              className="title-finding-detail"
              dangerouslySetInnerHTML={{ __html: renderInlineMd(f.detail) }}
            />
          </button>
        ))}
      </div>
    </>
  );
}
